{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "https://ceo-os.local/schemas/v1/joint-correction.schema.json",
  "title": "JointCorrection v1",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "schema_name",
    "schema_version",
    "contract_id",
    "produced_at",
    "producer",
    "payload_hash",
    "payload"
  ],
  "properties": {
    "schema_name": { "const": "joint-correction" },
    "schema_version": { "const": "1.0.0" },
    "contract_id": { "type": "string", "format": "uuid" },
    "produced_at": { "type": "string", "format": "date-time" },
    "producer": { "const": "ceo-os-joint-adapter" },
    "payload_hash": { "type": "string", "pattern": "^[a-f0-9]{64}$" },
    "payload": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "date",
        "business_fact",
        "founder_deviation",
        "single_joint_action",
        "owner",
        "deadline",
        "verification_metric",
        "board_context_id",
        "ceo_review_export_id",
        "derived_only"
      ],
      "properties": {
        "date": { "type": "string", "format": "date" },
        "business_fact": { "type": "string", "minLength": 1 },
        "founder_deviation": { "type": "string", "minLength": 1 },
        "single_joint_action": { "type": "string", "minLength": 1 },
        "owner": { "type": "string", "minLength": 1 },
        "deadline": { "type": "string", "format": "date-time" },
        "verification_metric": { "type": "string", "minLength": 1 },
        "board_context_id": { "type": "string", "format": "uuid" },
        "ceo_review_export_id": { "type": "string", "format": "uuid" },
        "derived_only": { "const": true }
      }
    }
  },
  "examples": [
    {
      "schema_name": "joint-correction",
      "schema_version": "1.0.0",
      "contract_id": "cbca9b2e-03d6-41c3-92ed-7889b8d5c6ec",
      "produced_at": "2026-07-26T21:35:00+08:00",
      "producer": "ceo-os-joint-adapter",
      "payload_hash": "f23038f8aea4b9ed8950401c0672fe04f826a54ee76cd2529f66f6260ef78a00",
      "payload": {
        "date": "2026-07-26",
        "business_fact": "当前唯一瓶颈是付费客户访谈不足。",
        "founder_deviation": "用系统建设替代客户验证。",
        "single_joint_action": "明日 11:00 前完成 3 次目标客户触达。",
        "owner": "founder",
        "deadline": "2026-07-27T11:00:00+08:00",
        "verification_metric": "完成触达 3 次并记录付款意愿。",
        "board_context_id": "1107166e-5c24-4a39-b675-15685144ae56",
        "ceo_review_export_id": "6d228e99-4f15-4dc1-9b9d-8d1d5437438d",
        "derived_only": true
      }
    }
  ]
}
